import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Search, ShoppingBag, Menu, X, PackageSearch } from "lucide-react";
import { useStore } from "@/context/Store";
import { Container } from "./common";

const NAV = [["/c/casa", "Casa"], ["/c/empresa", "Empresa"], ["/c/eventos", "Eventos"], ["/c/grupo", "Grupo"], ["/ideia", "Ideia personalizada"], ["/sobre", "Sobre"]];

export default function Header() {
  const { count, setCartOpen } = useStore();
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const nav = useNavigate();
  const submit = (e) => { e.preventDefault(); if (q.trim()) { nav(`/pesquisa?q=${encodeURIComponent(q.trim())}`); setOpen(false); } };
  const linkCls = ({ isActive }) => `text-sm font-medium transition-colors hover:text-[var(--violet)] ${isActive ? "text-[var(--violet)]" : ""}`;

  return (
    <header className="sticky top-0 z-40 border-b border-[var(--line)] bg-[var(--paper)]/85 backdrop-blur-xl">
      <Container className="flex h-20 items-center gap-6 lg:h-24">
        <Link to="/" data-testid="header-logo-link" className="flex shrink-0 items-center">
          <img src="/logo.jpg" alt="DUSA – início" className="h-16 w-16 rounded-2xl object-cover shadow-md ring-1 ring-[var(--line)] transition-transform duration-300 hover:scale-105 lg:h-20 lg:w-20" />
        </Link>
        <nav className="hidden flex-1 items-center gap-6 lg:flex">
          {NAV.map(([to, label]) => <NavLink key={to} to={to} className={linkCls} data-testid={`nav-${to.split("/").pop()}`}>{label}</NavLink>)}
        </nav>
        <form onSubmit={submit} className="ml-auto hidden items-center md:flex">
          <div className="relative">
            <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-[var(--muted-ink)]" />
            <input data-testid="header-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Pesquisar…" className="field w-44 !rounded-full !py-2 !pl-9 focus:w-60" style={{ transition: "width .3s ease, border-color .2s" }} />
          </div>
        </form>
        <Link to="/acompanhar" data-testid="header-track-link" className="ml-auto hidden items-center gap-1.5 rounded-full px-3 py-2 text-sm font-medium transition-colors hover:bg-[var(--lilac)] hover:text-[var(--violet)] md:ml-0 md:flex" title="Acompanhar pedido"><PackageSearch className="h-5 w-5" /><span className="hidden xl:inline">Acompanhar pedido</span></Link>
        <button data-testid="header-cart-button" onClick={() => setCartOpen(true)} className="relative ml-auto rounded-full p-2.5 transition-colors hover:bg-[var(--lilac)] md:ml-0" aria-label="Abrir carrinho">
          <ShoppingBag className="h-5 w-5" />
          {count > 0 && <span data-testid="header-cart-count" className="brand-gradient absolute -right-0.5 -top-0.5 flex h-5 min-w-5 items-center justify-center rounded-full px-1 text-[11px] font-bold text-white">{count}</span>}
        </button>
        <button data-testid="header-menu-toggle" onClick={() => setOpen(!open)} className="rounded-full p-2.5 hover:bg-[var(--lilac)] lg:hidden" aria-label="Menu">
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </Container>
      {open && (
        <div className="border-t border-[var(--line)] bg-[var(--paper)] lg:hidden" data-testid="mobile-menu">
          <Container className="flex flex-col gap-4 py-5">
            <form onSubmit={submit}><input data-testid="mobile-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Pesquisar produtos…" className="field rounded-full" /></form>
            {NAV.map(([to, label]) => <NavLink key={to} to={to} onClick={() => setOpen(false)} className="text-lg font-semibold">{label}</NavLink>)}
            <NavLink to="/acompanhar" onClick={() => setOpen(false)} className="text-lg font-semibold" data-testid="mobile-track-link">Acompanhar pedido</NavLink>
            <NavLink to="/perguntas" onClick={() => setOpen(false)} className="text-lg font-semibold">Perguntas frequentes</NavLink>
          </Container>
        </div>
      )}
    </header>
  );
}
